import React from 'react';
import PropTypes from 'prop-types';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { camelCase } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FeeCalculator from './FeeCalculator';
import ArbitrationFeeTable from './ArbitrationFeeTable';

const styles = theme => ({
    container: {
        width: '95%'
    },
    root: {
      width: '95%',
      minHeight: '500px',
      //marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      margin: '0 Auto',
      //display: 'flex',
      //justifyContent: 'center',
    },
    table: {
      tableLayout: 'auto',
      minWidth: 300,
    },
    header:{
        backgroundColor: 'primary',
    },
    leftCell: {
        borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    },
  });

function createData(amountInDispute, fee) {
  return { amountInDispute, fee};
}

/*const rows = [
    createData('At or below $1,000', '100.00'),
    createData('At or between $1,001 and $2,000', '200.00'),
    createData('At or between $2,001 and $5,000', '500.00'),
    createData('At or between $5,001 and $10,000', '1,000.00'),
    createData('At or between $10,001 and $15,000', '1,500.00'),
    createData('At or between $15,001 and $20,000', '2,000.00'),
    createData('At or between $20,001 and $50,000', '2,500.00'),
    createData('At or between $50,001 and $100,000', '5,000.00'),
    createData('At or between $100,001 and $150,000', '7,500.00'),
    createData('At or between $150,001 and $250,000', '12,500.00'),
    createData('At or between $250,001 and $500,00', '25,000.00'),
    createData('At or between $500,00 and $1,500,000', '37,500.00'),
    createData('At or between $1,50,001 and $3,000,000', '75,000.00'),
    createData('At or between $3,00,001 and $10,000,000', '125,000.00'),
    createData('Over $10,000,000', '175,000.00'),
  ];*/

const ArbitratorFeeCalculator = (props) => {
    const { classes } = props;
    return (
        <div className={classes.root}>
            <ArbitrationFeeTable />
            <FeeCalculator />
        </div>
    );
}

export default withStyles(styles)(ArbitratorFeeCalculator);